var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldReceipt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.48 3.64c-.22-.28-.51-.43-.85-.43-.53 0-1.17.35-1.86 1.09-.82.88-2.08.81-2.8-.15l-1.01-1.34c-.4-.54-.93-.81-1.46-.81-.53 0-1.06.27-1.46.81L9.02 4.16c-.71.95-1.96 1.02-2.78.15l-.01-.01C5.1 3.09 4.09 2.91 3.52 3.64c-.02.01-.02.02-.02.03-.36.77-.5 1.85-.5 3.37v9.92c0 1.52.14 2.6.5 3.37 0 .01.01.03.02.04.58.72 1.58.54 2.71-.67l.01-.01c.82-.87 2.07-.8 2.78.15l1.02 1.35c.4.54.93.81 1.46.81.53 0 1.06-.27 1.46-.81l1.01-1.34c.72-.96 1.98-1.03 2.8-.15.69.74 1.33 1.09 1.86 1.09.34 0 .63-.14.85-.42.01-.01.02-.03.02-.04.36-.77.5-1.85.5-3.37V7.04c0-1.52-.14-2.6-.5-3.37 0-.01 0-.02-.02-.03zM8 14.5c-.41 0-.75-.34-.75-.75S7.59 13 8 13h6c.41 0 .75.34.75.75s-.34.75-.75.75H8zM8 11c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldReceipt2);
export default __webpack_public_path__ + "static/media/vuesax-bold-receipt-2.145d0b1487b4cf0a239c64ac3becd288.svg";
export { ForwardRef as ReactComponent };